export default {"src":"/login-app/[GIT_HASH]/_next/static/media/hourglass.2cda5123.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};